"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.easeQuadInOut = void 0;
var easeQuadInOut = function (percentage) {
    return ((percentage *= 2) <= 1 ? percentage * percentage : --percentage * (2 - percentage) + 1) / 2;
};
exports.easeQuadInOut = easeQuadInOut;
